import React from "react";
import { InlineStack, LegacyCard as Card, Text } from "@shopify/polaris";
import { getPasswordCriteriaState } from "lib/helpers/passwordCriteria";

const PasswordRequirements = ({ password = "", isTouched = false }) => {
  const criteriaState = getPasswordCriteriaState(password);

  return (
    <Card sectioned>
      <Text as="p" variant="bodyMd" fontWeight="semibold">
        PASSWORD REQUIREMENTS:
      </Text>
      {criteriaState.map((criteria) => {
        const isCriteriaFailed = isTouched && !criteria.isValid;
        const icon = criteria.isValid ? "\u2713" : "\u2715";
        const tone = criteria.isValid ? "success" : isCriteriaFailed ? "critical" : "subdued";

        return (
          <InlineStack key={criteria.key} gap="200" blockAlign="center">
            <Text as="span" tone={tone}>
              {icon}
            </Text>
            <Text as="span" tone={tone}>
              {criteria.label}
            </Text>
          </InlineStack>
        );
      })}
    </Card>
  );
};

export default PasswordRequirements;
